APP.home = function () {
	return true;
};
